export const loginRequest = {
  scopes: ["openid", "profile", "email", "https://qarby.onmicrosoft.com/b3151b69-8e5d-44eb-934e-b0a96a8f5d57/access_as_user"]
};
